import { pointsToMiraiMile } from "@roman/shared/utils/pointsToMiraiMile";
import { useNavigate } from "react-router-dom";
import ArrowSvg from "./img/arrow.svg";
import BannerImg from "./img/card_sample.png";

type Props = {
  points: number;
};

export const PointBalance = ({ points }: Props) => {
  const navigate = useNavigate();

  return (
    <div className="grid gap-3" onClick={() => navigate("/record")}>
      <p className="text-xl font-bold -tracking-[.01em] text-black">所持ミライマイル</p>
      <div className="p-[20px] border border-[#F2D89B] border-solid rounded-md cursor-pointer bg-[#FFFDEF] w-full">
        <div className="grid grid-cols-[auto_1fr_auto] w-full gap-[15px] items-center">
          <div>
            <img src={BannerImg} alt="" width="80px" />
          </div>
          <div className="grid gap-y-[5px]">
            <div className="flex items-baseline font-roboto gap-x-[5px]">
              <div className="text-[38px] leading-none font-black text-gold-gradient">{pointsToMiraiMile(points)}</div>
            </div>
          </div>
          <div>
            <img src={ArrowSvg} alt="arrow" />
          </div>
        </div>
      </div>
    </div>
  );
};
